var cov_1q8dn5saz4 = function () {
  var path = "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/treatfile.js",
      hash = "0c638db08ceed11862e81afa83893650fca7e403",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/treatfile.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();